export default __webpack_public_path__ + "static/media/otcLogo.8c5e519f.svg";